import React, {useState} from 'react';
import {paginationLeft, paginationRight} from 'assets/images/images';

export default function Pagination({total, current, onPageChange}) {
  const [page, setPage] = useState(1);

  const currentPage = current || page;
  const formattedCurrentPage = currentPage.toLocaleString();
  const formattedTotal = total?.toLocaleString();

  const handlePageChange = newPage => {
    if (newPage < 1 || newPage > total) return;

    if (onPageChange) {
      onPageChange(newPage);
    } else {
      setPage(newPage);
    }
  };

  return (
    <div className="flex items-center justify-center gap-[10px]">
      <button
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={currentPage <= 1}
        className="flex items-center justify-center w-6 h-5 bg-white shadow-pagination rounded-[6px] border border-[#F7F9FC] disabled:opacity-50"
        aria-label="Previous page"
      >
        <img src={paginationLeft} />
      </button>

      <div className="text-sm font-medium text-[#5C688E]">
        <span className="text-deepBlue">{formattedCurrentPage}</span>/
        {formattedTotal}
      </div>

      <button
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={currentPage >= total}
        className="flex items-center justify-center w-6 h-5 bg-white shadow-pagination rounded-[6px] border border-[#F7F9FC] disabled:opacity-50"
        aria-label="Next page"
      >
        <img src={paginationRight} />
      </button>
    </div>
  );
}
